import(/* webpackMode: "eager" */ "/home/runner/work/App-Dev-Access-Hub/App-Dev-Access-Hub/apps/web/app/global-error.tsx");
